var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.latest_risk_notice))]),_vm._v(" "),_c('el-button',{staticClass:"ignore-button",on:{"click":_vm.onClickIgnoreNotice}},[_vm._v("忽略")]),_vm._v(" "),_c('el-button',{staticClass:"read-button",on:{"click":_vm.onClickReadNotice}},[_vm._v("检查风控通知")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e00b48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/risknoticepopup.vue
// module id = null
// module chunks = 